import { jsxs as x, jsx as i } from "react/jsx-runtime";
import c from "react";
import f, { css as u } from "styled-components";
import { R as S } from "../chunks/index.cff5baaf.js";
import { n as M } from "../chunks/array.c8fbbd1f.js";
const N = f.div.withConfig({
  displayName: "RateInput",
  componentId: "sc-1uetvkq-0"
})(["display:inline-flex;align-items:center;", " ", ""], ({
  disabled: t
}) => t && u(["opacity:var(--disabled-opacity);", "{cursor:not-allowed;pointer-events:none;", "{color:var(--disabled-icon-color);}}"], d, m), ({
  disabled: t
}) => !t && u(["", ":focus-visible{border-radius:var(--border-radius-circular);outline-color:var(--_focus-border-color);outline-width:var(--_focus-border-width);outline-style:solid;outline-offset:2px;}"], d)), d = f.button.withConfig({
  displayName: "Item",
  componentId: "sc-1uetvkq-1"
})(["all:unset;width:var(--size-6x);height:var(--size-6x);display:flex;align-items:center;justify-content:center;cursor:pointer;", ""], ({
  selected: t
}) => t && u(["", "{color:var(--selected-icon-color);}"], m)), m = f(S).withConfig({
  displayName: "Icon",
  componentId: "sc-1uetvkq-2"
})([""]), _ = c.forwardRef(({
  disabled: t,
  inputProps: n,
  onClick: p,
  id: v,
  ariaLabel: y,
  ...R
}, w) => {
  const [a, r] = c.useState(0), [l, h] = c.useState(null), s = c.useRef(null), g = (e, o) => {
    if (r(o + 1), e.type === "click" && (l === o ? (r(0), h(null)) : h(o), p && p(new CustomEvent("click", {
      detail: o
    })), n != null && n.onChange)) {
      s.current.value = a.toString();
      const b = new Event("input", {
        bubbles: !0
      });
      s.current.dispatchEvent(b), n.onChange(b);
    }
  }, k = () => {
    r(l !== null ? l + 1 : 0);
  }, C = (e) => e < a ? "RateSelected" : "RateLine", I = (e) => e < a;
  return /* @__PURE__ */ x(N, { disabled: t, role: "group", "aria-label": y, id: v, ref: w, "data-rango-component": "rango-input-rate", "data-is-rango": !0, ...R, children: [
    M(5).map((e) => /* @__PURE__ */ i(d, { selected: I(e), "aria-labelledby": v, role: "checkbox", "aria-checked": I(e), "aria-disabled": t, onClick: (o) => g(o, e), onMouseOver: (o) => g(o, e), onMouseOut: k, children: /* @__PURE__ */ i(m, { size: "MD", icon: C(e) }) }, e)),
    /* @__PURE__ */ i("input", { ...n, type: "hidden", value: a, ref: s })
  ] });
});
_.displayName = "RangoInputRate";
export {
  _ as RangoInputRate
};
